import escapeRegExp from 'lodash/escapeRegExp'
import {
	PAGE_PATH_LOGIN,
	PAGE_PATH_REGISTER,
	PAGE_PATH_RESET_PASSWORD,
	PAGE_PATH_SALES_AGENT_LOGIN,
	PAGE_PATH_SALES_AGENT_RESET_PASSWORD,
	PATHNAME_ERROR,
	PATHNAME_ERROR_500,
	PATHNAME_MAINTENANCE,
} from '../constants'

export const isFullURL = (src) => /^https?:\/\//i.test(src)
export const isEmailTo = (src) => /^mailto/i.test(src)
export const isTel = (src) => /^tel/i.test(src)
export const isJavascript = (src) => /^javascript:/i.test(src)
export const isSingleHashtag = (src) => /^#$/.test(src)
export const isRelativeUrl = (src) => {
	const urlOrigin = window.location.origin
	const pathOrigin = new URL(src, urlOrigin).origin
	return urlOrigin === pathOrigin
}

// Keep in sync with /packages/scripts/src/utils/domains.js
// TODO: read next.config.js and use trailingSlash
export const addTrailingSlash = (url) => {
	if (!url) return '/'
	if (/^(?:https?:\/\/)?(?:.*\/)?[^/.#?]+$/.test(url)) {
		return `${url}/`
	} else {
		return url
	}
}

export const addLeadingSlash = (url) => {
	if (!url) return '/'
	if (/^https?:\/\//.test(url)) {
		return url
	}
	if (/^#/.test(url)) {
		return url
	}

	// remove all leading slashes and add one
	return '/' + url.replace(/^\/+/, '')
}

export const removeTrailingSlashes = (url) => url.replace(/\/+$/, '')
export const removeLeadingSlashes = (url) => url.replace(/^\/+/, '')

export const trimSlashes = (str) => str?.replace(/^\/+|\/+$/g, '')
export const keepOneSlash = (str) => str?.replace(/^\/+|\/+$/g, '/')

export const isErrorPage = (pathname) => pathname === PATHNAME_ERROR || pathname === PATHNAME_ERROR_500
export const isMaintenancePage = (pathname) => pathname === PATHNAME_MAINTENANCE
export const isLoginPage = (path) => new RegExp(`^${escapeRegExp(PAGE_PATH_LOGIN)}(?:\\?.+)?$`).test(path)
export const isResetPasswordPage = (path) =>
	new RegExp(`^${escapeRegExp(PAGE_PATH_RESET_PASSWORD)}(?:\\?.+)?$`).test(path)

export const isSalesAgentLoginPage = (path) =>
	new RegExp(`^${escapeRegExp(PAGE_PATH_SALES_AGENT_LOGIN)}(?:\\?.+)?$`).test(path)
export const isSalesAgentResetPasswordPage = (path) =>
	new RegExp(`^${escapeRegExp(PAGE_PATH_SALES_AGENT_RESET_PASSWORD)}(?:\\?.+)?$`).test(path)

export const isRegisterPage = (path) => new RegExp(`^${escapeRegExp(PAGE_PATH_REGISTER)}(?:\\?.+)?$`).test(path)

export const parseParams = (querystring) => {
	// parse query string
	const params = new URLSearchParams(querystring)

	const obj = {}

	// iterate over all keys
	for (const key of params.keys()) {
		if (params.getAll(key).length > 1) {
			obj[key] = params.getAll(key)
		} else {
			obj[key] = params.get(key)
		}
	}

	return obj
}

export const cleanPathFromParamsAndHashtag = (path) => path.replace(/\?.*/, '').replace(/#.*/, '')

export const isValidPreviousPath = (path) => path && path.startsWith('/') && isRelativeUrl(path)
/**
 * @description Prevent XSS attacks by sanitizing the previous path.
 * If the previous path is not a valid path, it will return undefined.
 * @param {string} url - The previous path.
 * @returns {string|undefined} The sanitized previous path or undefined.
 */
export const sanitizePreviousPath = (url) => (isValidPreviousPath(url) ? url : undefined)
